import { render, staticRenderFns } from "./DetalhesConvenio.vue?vue&type=template&id=35fed691&"
import script from "./DetalhesConvenio.vue?vue&type=script&lang=js&"
export * from "./DetalhesConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports